/* eslint-disable react-hooks/exhaustive-deps */
import { DependencyList, useEffect } from "react";

export function useAsyncFn(fn: Function, deps?: DependencyList, unsubscribe?: () => void) {
    useEffect(() => {
        fn();
        return unsubscribe;
    }, deps);
}
